import { WSText, toWSDateString } from "@wingspanhq/fe-component-library";
import {
  FrequencyAndScheduleStatus,
  IInvoiceTemplate
} from "@wingspanhq/payments/dist/interfaces";
import { isSameDate } from "../../../utils/dates";
import { getNextInvoiceSendDate } from "../../utils";

type Props = {
  invoiceTemplate: IInvoiceTemplate;
};

export const InvoiceTemplateRecentUpdate: React.FC<Props> = ({
  invoiceTemplate
}) => {
  return invoiceTemplate.status === FrequencyAndScheduleStatus.Draft ? (
    isSameDate(invoiceTemplate.createdAt, invoiceTemplate.updatedAt) ? (
      <WSText.ParagraphXs color="gray500" align="right">
        Created {toWSDateString(invoiceTemplate.createdAt, "monthDate")}
      </WSText.ParagraphXs>
    ) : (
      <WSText.ParagraphXs color="gray500" align="right">
        Last updated {toWSDateString(invoiceTemplate.updatedAt, "monthDate")}
      </WSText.ParagraphXs>
    )
  ) : invoiceTemplate.status === FrequencyAndScheduleStatus.Active ? (
    invoiceTemplate.frequency ? (
      <WSText.ParagraphXs color="gray500" align="right">
        Next send date{" "}
        {toWSDateString(getNextInvoiceSendDate(invoiceTemplate), "monthDate")}
      </WSText.ParagraphXs>
    ) : (
      <WSText.ParagraphXs color="gray500" align="right">
        Send date{" "}
        {toWSDateString(invoiceTemplate.scheduleDates?.[0]?.date, "monthDate")}
      </WSText.ParagraphXs>
    )
  ) : null;
};
